import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../../base/outline-element/outline-element';

import componentStyles from './ghs-provider-detail.css.lit';

/**
 * Provider detail Component.
 * @element ghs-provider-detail
 */
@customElement('ghs-provider-detail')
export class GhsProviderDetail extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Term
   */
  @property()
  term: string;

  render(): TemplateResult {
    return html`
      <div class="provider-detail">
        <div class="term">${this.term}</div>
        <div class="description">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
